var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -405) translate(24 389) translate(0 16) translate(0 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 27.444,
    fill: "#1A1876",
    rx: 3.167
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.893 18.05h-2.208l-1.656-6.388c-.078-.294-.245-.554-.49-.676-.613-.308-1.288-.552-2.025-.676v-.246h3.557c.491 0 .86.37.92.799l.86 4.607 2.207-5.406h2.147l-3.312 7.985zm4.54 0h-2.086l1.717-7.986h2.085l-1.717 7.985zm4.414-5.774c.062-.43.43-.676.86-.676.674-.061 1.41.062 2.023.369l.369-1.72c-.614-.246-1.29-.369-1.902-.369-2.024 0-3.497 1.106-3.497 2.641 0 1.168 1.044 1.781 1.78 2.15.797.369 1.104.615 1.042.983 0 .553-.613.798-1.226.798-.736 0-1.473-.184-2.147-.491l-.368 1.72c.736.306 1.533.43 2.27.43 2.269.06 3.68-1.044 3.68-2.703 0-2.089-2.884-2.21-2.884-3.132zM32.03 18.05l-1.656-7.985h-1.779c-.368 0-.736.246-.859.614L24.67 18.05h2.147l.428-1.167h2.638l.245 1.167h1.902zM28.9 12.215l.613 3.009h-1.718l1.105-3.01z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.efb88827542d5b6ebe8e4a3ebe422f08.svg";
export { ForwardRef as ReactComponent };